export default {
  TOGGLE_SIDEBAR_MINIFIED (state) {
    state.sidebarMinified = !state.sidebarMinified;
  },
  TOGGLE_SIDEBAR_MOBILE (state) {
    state.sidebarMobile = !state.sidebarMobile;
    state.sidebarMinified = false;
  },
};
